// extracted by mini-css-extract-plugin
export default {"primaryRecordsOnly":"RotatedRecords_primaryRecordsOnly__YYa5m"};